var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"share-btn twitter-share-button",on:{"click":_vm.click}},[_c('vk-icon',{attrs:{"icon":"twitter","ratio":"0.8"}}),_vm._v(_vm._s(_vm.$t('SHARE_BY_TWEET')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }